import { Navigate } from "react-router-dom";
import { useAppSelector } from "../hooks/storeHooks";
import { blockedPostalCodes } from "../constants/blockedPostalCodes";
import { useRef } from "react";

type Props = {
    children: JSX.Element;
};

export const ProtectedQuoteRoute = ({ children }: Props) => {

    const userCP = useAppSelector(state => state.DataCotizador.userCP);

    const hasEntered = useRef(false);

    const isValid =
        userCP &&
        userCP.length === 5 &&
        !blockedPostalCodes.has(userCP);

    if (!hasEntered.current) {
        if (!isValid) {
            return <Navigate to="/" replace />;
        }

        hasEntered.current = true;
    }

    return children;
};